import { defineMessages } from 'react-intl';

export const toolUseRowMessages = defineMessages({
  status: {
    defaultMessage:
      '{status, select, running {Running} complete {Complete} error {Error} cancelled {Canceled} pending_approval {Pending approval} streaming_input {Receiving input} queued {Queued} other {Unknown}}',
    id: 'txTcRWudZw',
    description: 'Current lifecycle status of a tool call',
  },
  subAgent: {
    defaultMessage: 'Sub-agent',
    id: 'v5sMBRsMbd',
    description: 'Badge on a tool-use row executed by a sub-agent',
  },
  inputSummary: {
    defaultMessage: 'Input',
    id: 'LDGl+grlFL',
    description: 'Disclosure summary for tool input JSON',
  },
  errorHeading: {
    defaultMessage: 'Error',
    id: 'NNAiUnDIOe',
    description: 'Heading above tool error output',
  },
  outputHeading: {
    defaultMessage: 'Output',
    id: '14WdzlbAeH',
    description: 'Heading above successful tool output',
  },
  approvalRequired: {
    defaultMessage: 'Approval required',
    id: '4sV8q27Jqp',
    description: 'Heading on inline human approval controls for a tool',
  },
  inputPlaceholder: {
    defaultMessage: 'Tool input JSON',
    id: 'AocYE3DMxT',
    description: 'Placeholder for editable tool input during approval',
  },
  reasonPlaceholder: {
    defaultMessage: 'Optional reason',
    id: 'UBen3cZ+vI',
    description: 'Placeholder for approval deny/approve reason',
  },
  inputNotAnObject: {
    defaultMessage: 'Modified input must be a JSON object.',
    id: 'V+0H7gwSfo',
    description: 'Validation error under the editable tool input during approval',
  },
  inputInvalidJson: {
    defaultMessage: 'Modified input must be valid JSON.',
    id: 'QBhXnrEkTJ',
    description: 'Validation error under the editable tool input during approval',
  },
  deny: {
    defaultMessage: 'Deny',
    id: 'PvhHF4QChd',
    description: 'Deny a pending tool approval',
  },
  approve: {
    defaultMessage: 'Approve',
    id: 'WAsQmm9l1v',
    description: 'Approve a pending tool approval',
  },
});
